import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';

/* Actions */
import * as loginActions from '../../actions/login/index';
import * as dashboardActions from '../../actions/dashboard/index';
import * as headerActions from '../../actions/header/index';
import * as tagsActions from '../../actions/common/tags/index';
import * as geozonesActions from '../../actions/common/geozones/index';
import * as workingShiftGroupsActions from '../../actions/common/working_shift_groups/index';
import * as surveyActions from '../../actions/survey/index';

/* Style */
import '../../../../public/style/dashboard.scss';

import { localStoreFN } from '../../store/localStorage';
import ObjGeneral from '../function';
import Constants from '../function/constants.js';

/* Components */
import UserProfile from '../user_profile/';
import DetailTruck from '../detail_truck/';
import SummaryTruck from '../summary_truck/';
import SummaryInspections from '../summary_inspections/';
import DetailInspection from '../detail_inspection/';
import SummaryNfa from '../summary_nfa/';
import DetailNfa from '../detail_nfa/';
import DriverNfa from '../driver_nfa/';
import SummaryFfdSleep from '../summary_ffd_sleep/';
import LastDataFfdSleep from '../last_data_ffd_sleep/';
import LastDataFfdPvt from '../last_data_ffd_pvt/';
import SummaryFfdPvt from '../summary_ffd_pvt/';
import AccountUser from '../account_user/';
import TasksManager from '../tasks_manager/';
import DetailWaitingTimes from '../detail_waiting_times/';
import DriverRoadwarning from '../driver_roadwarning/';
import DriverBehavior from '../driver_behavior/';
import DriverRecord from '../driver_record/';
import AccountSetting from '../account_setting/';
import DriverFulfillment from '../driver_fulfillment/';
import DetailFulfillment from '../detail_fulfillment/';
import SummaryFulfillment from '../summary_fulfillment/';
import Detail_roadwarning from '../detail_roadwarning/';
import DetailBehaviour from '../detail_behaviour/';
import Home from '../home/';
import Nav from '../nav/';
import Header from '../header/';
import SummaryFatigue from '../summary_fatigue/';
import DetailFatigue from '../detail_fatigue/';
import DriverFatigue from '../driver_fatigue/';
import SummaryRoadwarning from '../summary_roadwarning/';
import SummaryBehaviour from '../summary_behaviour';
import FlowAdminDetail from '../flow_admin_detail/';
import FlowAdminRcaReports from '../flow_admin_rca_reports/';
import FlowApplicantDetail from '../flow_applicant_detail/';
import FlowsHistory from '../flows_history/';
import AssignmentList from '../assignment_list/index';
import AccountDriver from '../account_driver/';
import HomologationDriver from '../homologation_driver/';
import HomologationVehicle from '../homologation_vehicle/index';
import HomologationSemiTrailer from '../homologation_semi_trailer/index';
import AccountVehicle from '../account_vehicle/';
import AccountSemiTrailer from '../account_semi_trailer/';
import AccountGeozone from '../account_geozone/';
import AccountTag from '../account_tag/';
import AccountExtendedProperty from '../account_extended_property/';
import AccountGeozoneCategory from '../account_geozone_category/';
import AccountList from '../account_list/index';
import AccountWorkingShiftGroup from '../account_working_shift_group/';
import Authorization from '../authorization/';
import ModalSurvey from '../../components/survey/modalSurvey';
import Expired from '../expired/index';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import String from '../../components/locales';
import DynamicList from '../dynamic_list/index';
import Allocator from '../allocator/index';
import Reports from '../reports';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSurvey: true,
      actualSurveyQuestion: 0,
      surveyAnswersAvg: 0,
      surveyAnswers: [],
      refreshTaskIndicatorsTimeoutFunction: null,
      breadcrum: ""
    };
  }

  async componentDidMount() {
    let auth = localStoreFN().getItem('auth');
    let lang = localStoreFN().getItem('lang');
    auth = auth === 'true';
    if (!auth) {
      // if you are not authenticated, redirect to the login and stop the execution of the following methods
      this.props.history.push('/');
      return;
    } else {
      if(this.props.location) {
        this.props.dashboardActions.trackPageRequest(this.props.location.pathname);
      }
    }
    // initial load APIS
    if(lang) {
      String.setLanguage(lang);
    }
    this.props.dashboardActions.handleLanguageChange(String);
    await this.props.dashboardActions.fetchDashboardDateApi();
    await this.props.dashboardActions.fetchDashboardSettingApi();
    await this.props.dashboardActions.fetchTaskManagerIndicatorsApi();
    await this.props.surveyActions.fetchSurvey();
    this.state.refreshTaskIndicatorsTimeoutFunction = setInterval(async () => {
      await this.props.dashboardActions.fetchTaskManagerIndicatorsApi();
    }, Constants.dashboard.taskIndicatorsRefreshTime);
  }

  componentWillUnmount() {
    clearInterval(this.state.refreshTaskIndicatorsTimeoutFunction);
  }

  loadBreadcrumbs = () => {
    var breadcrum = "";
    $("nav .nav_inner a.active").each(function() {
      if($(this).find(".text-box").length>0) {
        breadcrum = $(this).find(".text-box").html() + " / ";
      }
      else {
        breadcrum += $(this).html() + "   ";
      }
    });
    breadcrum = breadcrum.slice(0, -3);
    this.setState({
      breadcrum: breadcrum
    });
  };

  async componentDidUpdate(prevProps, prevState) {
    if(this.props.location && prevProps.location &&
      this.props.location.pathname != prevProps.location.pathname) {
      this.loadBreadcrumbs();
      this.props.dashboardActions.trackPageRequest(this.props.location.pathname);
    }

    if (this.props.setting) {
      if (this.props.setting !== prevProps.setting) {
        const obj = JSON.parse(this.props.setting.value);
        const filter = obj.generalSetting.filter;
        const isEnabledUbicationPVT = ObjGeneral.getIsEnabledUbicationPVT(obj);
        this.loadBreadcrumbs();
        await this.props.tagsActions.fetchTagsFatigueMainApi({ setting: filter, isEnabledUbicationPVT });
        await this.props.geozonesActions.fetchGeozonesApi();
        await this.props.workingShiftGroupsActions.fetchWorkingShiftGroupsApi();
      }
    }
  }

  handleLogOut = async () => {
    let lang = localStoreFN().getItem('lang');
    this.props.dashboardActions.resetDashboard();
    this.props.surveyActions.resetSurvey();
    this.props.headerActions.resetHeader();
    await this.props.actionsLogin.logOut();
    if(lang) {
      this.props.history.push('/lang/'+lang);
    }
    else {
      this.props.history.push('/');
    }
  };

  handleUserProfile = async () => {
    this.props.history.push('/dashboard/user_profile');
  };

  handleSurveyModal = async e => {
    e.stopPropagation();
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.showSurvey ? false : true;
      this.setState({ showSurvey: reset });
      if(!reset && this.props.statusSaveSurvey==null) {
        this.props.surveyActions.fetchSaveSurvey({
          answers: this.state.surveyAnswers
        });
        this.state.surveyAnswers = [];
        this.state.actualSurveyQuestion = 0;
        this.state.surveyAnswersAvg = 0;
      }
    }
  };

  handleChangeMenuState = () => {
    this.props.dashboardActions.changeMenuCollapseState();
    if(window && window.dispatchEvent) {
      window.dispatchEvent(new Event('resize'));
    }
  };

  hideSurveyModal = () => {
    if (this.state.showSurvey) {
      this.setState({ showSurvey: false });
    }
  };

  handleSurveyAnswer = e => {
    var answerValue = +e.target.dataset.answervalue;
    var questionData = JSON.parse(e.target.dataset.questiondata);
    var lastQuestion = e.target.dataset.lastquestion;

    questionData.answerValue = answerValue;
    this.state.surveyAnswers.push(questionData);

    if(lastQuestion) {
      this.props.surveyActions.fetchSaveSurvey({
        answers: this.state.surveyAnswers
      });
      this.state.surveyAnswers = [];
      this.state.actualSurveyQuestion = 0;
      this.state.surveyAnswersAvg += answerValue;
      this.state.surveyAnswersAvg =
        this.state.surveyAnswersAvg / this.props.datosSurvey.questions.length;
    }
    else {
      this.setState({
        actualSurveyQuestion: ++this.state.actualSurveyQuestion,
        surveyAnswersAvg: this.state.surveyAnswersAvg + answerValue
      });
    }
  };

  render() {
    let container = '';
    // state to true while the query arrives
    if (this.props.loading
      || this.props.loadingDate
      || this.props.loadingSurvey) {
      container = (
        <section className="main">
          <Loading language={this.props.language}/>
        </section>
      );
      // we validate if the token is active
    } else if (this.props.status === 401
      || this.props.statusDate === 401
      || this.props.statusSurvey === 401) {
      container = (
        <section className="main">
          <Expired history={this.props.history} />
        </section>
      );
      // query failed
    } else if (this.props.status === 501
      && this.props.statusDate === 501
      && this.props.statusSurvey === 501) {
      container = (
        <section className="main">
          <Message message={this.props.language.error.apiError} />
        </section>
      );
      /* No data */
    } else if (this.props.status === 500
      || this.props.statusDate === 500
      || this.props.statusSurvey === 500) {
      container = (
        <section className="main">
          <Message message={this.props.language.error.apiError500} />
        </section>
      );
    } else if (!this.props.setting) {
      container = (
        <div>
          <Route path={`${this.props.match.path}/account_setting`} component={AccountSetting} />
        </div>
      );
    } else {
      // we load the content but before we validate if we have the props language
      container = this.props.loadingLanguage ? (
        <section className="main">
          <Loading language={this.props.language}/>
        </section>
      ) : this.props.match.path == '/dashboard' ? (
        // the content
        <div>
          <Route exact path={this.props.match.path} component={Home} />
					<Route path={`${this.props.match.path}/user_profile`} component={UserProfile} />
          <Route path={`${this.props.match.path}/driver_nfa`} component={DriverNfa} />
          <Route path={`${this.props.match.path}/detail_nfa`} component={DetailNfa} />
          <Route path={`${this.props.match.path}/summary_nfa`} component={SummaryNfa} />
          <Route path={`${this.props.match.path}/summary_ffd_sleep`} component={SummaryFfdSleep} />
          <Route path={`${this.props.match.path}/last_data_ffd_sleep`} component={LastDataFfdSleep} />
          <Route path={`${this.props.match.path}/summary_ffd_pvt`} component={SummaryFfdPvt} />
          <Route path={`${this.props.match.path}/last_data_ffd_pvt`} component={LastDataFfdPvt} />
          <Route path={`${this.props.match.path}/detail_truck`} component={DetailTruck} />
          <Route
            path={`${this.props.match.path}/summary_inspections/:id_inspection?`}
            component={SummaryInspections}
          />
          <Route path={`${this.props.match.path}/summary_truck`} component={SummaryTruck} />
          <Route path={`${this.props.match.path}/account_user`} component={AccountUser} />
          <Route
            path={`${this.props.match.path}/tasks_manager/:id_task?`}
            component={TasksManager}
          />
          <Route
            path={`${this.props.match.path}/detail_waiting_times`}
            component={DetailWaitingTimes}
          />
          <Route
            path={`${this.props.match.path}/driver_roadwarning`}
            component={DriverRoadwarning}
          />
          <Route path={`${this.props.match.path}/driver_behavior`} component={DriverBehavior} />
          <Route path={`${this.props.match.path}/account_setting`} component={AccountSetting} />
          <Route
            path={`${this.props.match.path}/driver_fulfillment`}
            component={DriverFulfillment}
          />
          <Route
            path={`${this.props.match.path}/detail_fulfillment`}
            component={DetailFulfillment}
          />
          <Route
            path={`${this.props.match.path}/summary_fulfillment`}
            component={SummaryFulfillment}
          />
          <Route
            path={`${this.props.match.path}/detail_roadwarning`}
            component={Detail_roadwarning}
          />
          <Route path={`${this.props.match.path}/detail_behaviour`} component={DetailBehaviour} />
          <Route path={`${this.props.match.path}/summary_fatigue`} component={SummaryFatigue} />
          <Route path={`${this.props.match.path}/detail_fatigue`} component={DetailFatigue} />
          <Route path={`${this.props.match.path}/driver_fatigue`} component={DriverFatigue} />
          <Route path={`${this.props.match.path}/driver_record`} component={DriverRecord} />
          <Route
            path={`${this.props.match.path}/summary_roadwarning`}
            component={SummaryRoadwarning}
          />
          <Route path={`${this.props.match.path}/summary_behaviour`} component={SummaryBehaviour} />
          <Route path={`${this.props.match.path}/flow_admin_detail`} component={FlowAdminDetail} />
          <Route path={`${this.props.match.path}/flow_admin_rca_reports`} component={FlowAdminRcaReports} />
          <Route path={`${this.props.match.path}/flow_applicant_detail`} component={FlowApplicantDetail} />
          <Route path={`${this.props.match.path}/flows_history`} component={FlowsHistory} />
          <Route path={`${this.props.match.path}/assignment_list`} component={AssignmentList} />
          <Route path={`${this.props.match.path}/allocator`} component={Allocator} />
          <Route path={`${this.props.match.path}/account_driver`} component={AccountDriver} />
          <Route path={`${this.props.match.path}/account_vehicle`} component={AccountVehicle} />
          <Route path={`${this.props.match.path}/account_semi_trailer`} component={AccountSemiTrailer} />
          <Route path={`${this.props.match.path}/account_geozone`} component={AccountGeozone} />
          <Route path={`${this.props.match.path}/account_working_shift_group`} component={AccountWorkingShiftGroup} />
          <Route path={`${this.props.match.path}/account_tag`} component={AccountTag} />
          <Route path={`${this.props.match.path}/account_extended_property`} component={AccountExtendedProperty} />
          <Route path={`${this.props.match.path}/account_list`} component={AccountList} />
          {/*Dynamic list route */}
          <Route path={`${this.props.match.path}/dynamic_list`} component={DynamicList} />
          <Route
            path={`${this.props.match.path}/account_geozone_category`}
            component={AccountGeozoneCategory}
          />
          <Route
            path={`${this.props.match.path}/homologation_driver`}
            component={HomologationDriver}
          />
          <Route
            path={`${this.props.match.path}/homologation_vehicle`}
            component={HomologationVehicle}
          />
          <Route
            path={`${this.props.match.path}/homologation_semi_trailer`}
            component={HomologationSemiTrailer}
          />
          <Route path={`${this.props.match.path}/authorization`} component={Authorization} />
          <ModalSurvey
            handleModal={this.handleSurveyModal}
            hideModal={this.hideSurveyModal}
            handleAnswer={this.handleSurveyAnswer}
            modal={this.state.showSurvey}
            datos={this.props.datosSurvey}
            actualSurveyQuestion={this.state.actualSurveyQuestion}
            surveyAnswersAvg={this.state.surveyAnswersAvg}
            statusSave={this.props.statusSaveSurvey}
            loadingSave={this.props.loadingSaveSurvey}
            dataSave={this.props.datosSaveSurvey}
            language={this.props.language ? this.props.language : ''}
          />
          <Route
            path={`${this.props.match.path}/reports`}
            component={Reports}
          />
        </div>
      ) : (
        <div>
          <Route
            path={`${this.props.match.path}/detail_inspection/:id_inspection`}
            component={DetailInspection}
          />
        </div>
      );
    }
    if (this.props.match.path == '/dashboard') {
      return (
        <main className={this.props.menuCollapse ? "menu_collapse" : ""}>
          <Header
            handleLogOut={this.handleLogOut}
            handleUserProfile={this.handleUserProfile}
            history={this.props.history}
          />
          <div className="container">
            { this.props.menuCollapse && (<div className="breadcrum">{this.state.breadcrum}</div>)}
            <Nav
              status={this.props.status}
              history={this.props.history}
              handleChangeMenuState={this.handleChangeMenuState}
              menuCollapse={this.props.menuCollapse}
            />
            {container}
          </div>
        </main>
      );
    } else {
      return <main className="fullscreen-view">{container}</main>;
    }
  }
}

const mapStateToProps = state => ({
  loading: state.reducer.dashboard.loading,
  statusTags: state.reducer.tags.status,
  statusWorkingShiftGroups: state.reducer.workingShiftGroups.status,
  statusGeozones: state.reducer.geozones.status,
  loadingDate: state.reducer.dashboard.loadingDate,
  status: state.reducer.dashboard.status,
  statusDate: state.reducer.dashboard.statusDate,
  setting: state.reducer.dashboard.setting,
  loadingTag: state.reducer.tags.loading,
  loadingGeozones: state.reducer.geozones.loading,
  loadingWorkingShiftGroups: state.reducer.workingShiftGroups.loading,
  loadingLanguage: state.reducer.dashboard.loadingLanguage,
  language: state.reducer.dashboard.language,
  datosSurvey: state.reducer.survey.datos,
  statusSurvey: state.reducer.survey.status,
  loadingSurvey: state.reducer.survey.loading,
  datosSaveSurvey: state.reducer.survey.dataSave,
  statusSaveSurvey: state.reducer.survey.statusSave,
  loadingSaveSurvey: state.reducer.survey.loadingSave,
  menuCollapse: state.reducer.dashboard.menuCollapse
});

const mapDispatchToProps = dispatch => ({
  actionsLogin: bindActionCreators(loginActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  headerActions: bindActionCreators(headerActions, dispatch),
  tagsActions: bindActionCreators(tagsActions, dispatch),
  geozonesActions: bindActionCreators(geozonesActions, dispatch),
  workingShiftGroupsActions: bindActionCreators(workingShiftGroupsActions, dispatch),
  surveyActions: bindActionCreators(surveyActions, dispatch),
});

Dashboard.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./source/client/containers/dashboard/index.jsx